import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { CCard, CCardBody } from "@coreui/react";
import DateRangeDropdown from "./DateRangeDropdown";

// (c) Total transaction count by day / month / year, stacked success vs failed.
const TransactionVolumeCard = ({
  volumeData,
  dateRange,
  setDateRange,
  groupBy,
  setGroupBy,
}) => {
  const chartRef = useRef(null);

  const series = (volumeData && volumeData.series) || [];

  useEffect(() => {
    if (!chartRef.current) {
      return;
    }
    const chart = echarts.init(chartRef.current);

    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      grid: {
        bottom: "18%",
      },
      legend: {
        bottom: "0%",
        left: "center",
      },
      xAxis: {
        type: "category",
        data: series.map((row) => row.period),
        axisLabel: {
          rotate: series.length > 12 ? 45 : 0,
        },
      },
      yAxis: {
        type: "value",
        minInterval: 1,
      },
      series: [
        {
          name: "Success",
          type: "bar",
          stack: "transactions",
          data: series.map((row) => row.success_count),
          itemStyle: { color: "#16A34A" },
        },
        {
          name: "Failed",
          type: "bar",
          stack: "transactions",
          data: series.map((row) => row.failed_count),
          itemStyle: { color: "#DC2626" },
        },
      ],
    };

    chart.setOption(option);

    return () => {
      chart.dispose();
    };
  }, [volumeData]);

  const totalTransactions = (volumeData && volumeData.totalTransactions) || 0;
  const totalSuccess = (volumeData && volumeData.totalSuccess) || 0;
  const totalFailed = (volumeData && volumeData.totalFailed) || 0;

  return (
    <CCard className="border-light">
      <CCardBody style={{ overflowX: "auto" }}>
        <span>Number of Transactions</span>
        <ul className="nav nav-pills mt-3">
          {[
            ["day", "Daily"],
            ["month", "Monthly"],
            ["year", "Yearly"],
          ].map(([value, label]) => (
            <li className="nav-item" key={value}>
              <a
                className={`nav-link ${groupBy === value ? "active" : ""}`}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setGroupBy(value);
                }}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
        <DateRangeDropdown dateRange={dateRange} setDateRange={setDateRange} />
        <div
          ref={chartRef}
          style={{ height: "400px", width: "100%", margin: "5px auto" }}
        ></div>
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <span style={{ fontSize: "13px", color: "#555E67" }}>
            Total: <strong>{totalTransactions.toLocaleString()}</strong>
            {" · "}Success:{" "}
            <strong style={{ color: "#16A34A" }}>
              {totalSuccess.toLocaleString()}
            </strong>
            {" · "}Failed:{" "}
            <strong style={{ color: "#DC2626" }}>
              {totalFailed.toLocaleString()}
            </strong>
          </span>
        </div>
      </CCardBody>
    </CCard>
  );
};

export default TransactionVolumeCard;
